// extracted by mini-css-extract-plugin
export default {"chat":"CompanionChat_chat__agdHJ","messages":"CompanionChat_messages__BGYr5","fallback":"CompanionChat_fallback__XIN9B"};